module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/ty_success.f81498de.png";